import React, { useState } from 'react'
import { createSuppression, formatDate, SUPPRESSION_DAYS } from './api'

// No scope or duration choice: both are fixed. The reason is required, here and at the route.
export const SuppressModal = (props: {
  domain: string
  hideModal: () => void
  onSuppressed: () => void
}) => {
  const { domain, hideModal, onSuppressed } = props
  const [reason, setReason] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const until = formatDate(new Date(Date.now() + SUPPRESSION_DAYS * 86400000))

  const submit = async () => {
    setSubmitting(true)
    setError(null)
    const response = await createSuppression(domain, reason.trim())
    if (response?.code === 201) {
      onSuppressed()
      hideModal()
      return
    }
    setError(response?.message || 'The suppression was not saved. Try again.')
    setSubmitting(false)
  }

  return (
    <div
      className="card-body"
      style={{ padding: 24, width: 520, maxWidth: '100%' }}
    >
      <div className="text-dark text-bigger text-bolder m-b-3">
        Suppress {domain}
      </div>

      <p className="text-dark m-b-3">
        Hides <strong>{domain}</strong> from Network comparison for{' '}
        {SUPPRESSION_DAYS} days, until <strong>{until}</strong>. It comes back
        after that, or earlier if someone unsuppresses it.
      </p>

      <div className="m-b-3">
        <div className="text-dark text-small text-bolder m-b-1">
          Why are you suppressing this?{' '}
          <span style={{ color: 'var(--text-red)' }}>*</span>
        </div>
        <div className="control" style={{ display: 'block' }}>
          <textarea
            value={reason}
            onChange={(event) => setReason(event.target.value)}
            placeholder="e.g. Exclusive deal with the current network until 2027."
            rows={3}
            autoFocus
            style={{ display: 'block', boxSizing: 'border-box' }}
          />
        </div>
        <div className="text-light text-smaller m-t-1">
          Required. Shown on the card and in the Suppressions tab.
        </div>
      </div>

      {error && (
        <div className="text-small m-b-2" style={{ color: 'var(--text-red)' }}>
          {error}
        </div>
      )}

      <div className="row row-space-between row-center">
        <span className="text-light text-smaller">
          Kept across nightly rebuilds.
        </span>
        <div className="row" style={{ gap: 8 }}>
          <button
            type="button"
            className="btn btn-white"
            onClick={hideModal}
            disabled={submitting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={submit}
            disabled={submitting || !reason.trim()}
          >
            {submitting ? 'Saving…' : 'Suppress'}
          </button>
        </div>
      </div>
    </div>
  )
}
